module.exports = __webpack_public_path__ + "assets/images/2551a7a9c906197a12708a4880078a42.png";